import React from 'react';
import AvatarSection from './AvatarSection';
import HeaderSection from './HeaderSection';
import LinksSection from './LinksSection';
import FooterSection from './FooterSection';

import {
  buildCompositeBackground,
  buildCardBodyCss,
  buildButtonStripCss,
  buttonRadius,
  buttonFontColor
} from '../utils/styleBuilders';

import avatarFallback from '../assets/avatar.jpg';

export default function PublicCard({ data }) {
  const { profile, appearance } = data || {};
  const rawLinks = data?.links || [];

  const handle = profile?.username ? `@${profile.username}` : '';
  const avatar = (profile?.avatar?.imageUrl && profile.avatar.imageUrl.trim()) || avatarFallback;
  const bio = profile?.biography?.text?.trim() || '';
  const showBio = !(profile?.biography?.enable === false);

  const containerStyle = React.useMemo( () => buildCompositeBackground(appearance), [appearance] );
  const cardStyle = React.useMemo( () => buildCardBodyCss(appearance), [appearance]);
  const stripStyle = React.useMemo( () => buildButtonStripCss(appearance?.links), [appearance?.links] );
  const radius = React.useMemo( () => buttonRadius(appearance?.links),[appearance?.links] );
  const fontColor = React.useMemo( () => buttonFontColor(appearance?.links), [appearance?.links] );

  const links = React.useMemo(() => {
    return [...rawLinks]
      .filter(l => l && l.title && l.url)               
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)); 
  }, [rawLinks]);

  return (
    <div className="canario-container" style={containerStyle}>
      <div className="canario-card" style={cardStyle}>
        <AvatarSection src={avatar} alt={handle ? `${profile?.username} avatar` : 'avatar'} />
        <HeaderSection handle={handle} bio={bio} showBio={showBio} />
        <LinksSection links={links} stripStyle={stripStyle} radius={radius} fontColor={fontColor} />
        <FooterSection profile={profile?.username}/>
      </div>
    </div>
  );
}
